import { bundledElements } from "./elements";

export default bundledElements.html5;
